var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 200,
    viewBox: "0 0 600 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ff3b3b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ff8c42",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "     M 60 140     C 60 90, 110 70, 140 110     C 170 70, 220 90, 220 140     C 220 160, 200 170, 180 160     C 160 150, 160 130, 140 130     C 120 130, 120 150, 100 160     C 80 170, 60 160, 60 140     Z",
    fill: "url(#grad)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 145,
    fontFamily: "Poppins, Montserrat, Arial, sans-serif",
    fontSize: 72,
    fontWeight: 700,
    fill: "url(#grad)",
    letterSpacing: 2
  }, "\n    URIMA\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4fb111b44a3ce2faeaef7925445f7f69.svg";
export { ForwardRef as ReactComponent };